import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { MainService } from './core/main.service';
import { AppConfig } from '../environments/environment';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'
import {Title} from "@angular/platform-browser";
import {Subscription, interval, timer} from 'rxjs';
import { ElectronService } from 'ngx-electron';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public debug:boolean = false;
  public smallerScreen:boolean;

  private datasServer:any;
  public datasName:any;
  public base:string;
  public datas:any;

  private activityDelay:number = 5*60*1000; //ms
  private activitySubscription:Subscription;

  public debugTxt:string;

  public current:string = 'loading';
  public step:number;

  public bgImage:any;

  public isVP:any;

  private videoFolders:any;
  public currentVideo:string;
  private videoSubscription:Subscription;
  public loop:boolean;

  public choice:number = -1;
  public choiceLetters:Array<string> = ['A', 'B', 'C', 'D', 'E'];



  public answers:Array<any>;
  public total:number;
  public conclusion:string;

  public properties:Array<any> = [
    { id: "separation", title: "...", description: "...", min: 10.0, max: 100.0, value: 20, inc: 10.0 },
    { id: "alignment", title: "...", description: "...", min: 10.0, max: 100.0, value: 20, inc: 10.0 },
    { id: "cohesion", title: "...", description: "...", min: 10.0, max: 100.0, value: 20, inc: 10.0 }
  ];
  public showHelp:any;

  private espaces:Array<any> = [
  {
    name: 'Végétale',
    color: '#fbab18'
  },
  {
    name: 'Animale',
    color: '#ee4991'
  },
  {
    name: 'Humaine',
    color: '#00aab0'
  },
  {
    name: 'Artificielle',
    color: '#ef4023'
  }
];
public espace = this.espaces[3];
public iframeUrl: any;

  @ViewChild('video', {static: false}) videoTag : ElementRef;
  @ViewChild('iframe', {static: false}) iframeTag : ElementRef;
  videoProgress:number = 0;

  constructor(
    private service: MainService,
    private sanitizer:DomSanitizer,
    private titleService: Title,
    private electron: ElectronService
  ) {
    this.log('constructor');
  }

  ngOnInit():void
  {
    this.log('ngOnInit');

    if (window.hasOwnProperty('process') && window['process'].hasOwnProperty('versions') && window['process']['versions'].hasOwnProperty('electron')) { // electron
      let response: any = this.electron.ipcRenderer.sendSync('ping');
      this.datasName = response.datas;
      this.service.base = response.base;
      this.base = this.service.base;
    } else {
      this.datasName = this.findGetParameter('datas');
      this.base = AppConfig.datasServer;
    }
    this.log("this.datasName", this.datasName);

    this.smallerScreen = (window.devicePixelRatio < 1 || window.innerWidth != 1920*2+1280);
    this.checkIfVP();
    this.loadDatas();

    window.addEventListener('idal-contact-event', (e) => {
      let info = e['detail'];
      this.log("Input contact name: " + info.name);
      let port = info.values.findIndex(elt => elt);
      if (port == 0){

      }
    });
  }

  checkIfVP():void
  {
    // Detect Wave System player in VP330 ou VP320
    this.isVP = navigator.userAgent.search("WSPlayer") != -1;
  }

  loadDatas():void
  {
    this.current = 'loading';
    this.service.loadDatas(this.datasName).subscribe((datas => {
      this.datas = datas;

      this.properties[0].title = this.datas.parameter0_title;
      this.properties[0].description = this.datas.parameter0_description;
      this.properties[1].title = this.datas.parameter1_title;
      this.properties[1].description = this.datas.parameter1_description;
      this.properties[2].title = this.datas.parameter2_title;
      this.properties[2].description = this.datas.parameter2_description;

      this.titleService.setTitle( this.datas.name );


      let birdsNb = 1*this.datas.birdsNb;
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('./assets/iframe/flamingo.html?birds='+birdsNb);

      this.service.loadVideoFolders(this.datasName).subscribe((datas) => {
        this.videoFolders = datas;
        this.start();
      });

    }));
  }

  start():void
  {
    this.bgImage = this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+this.datas.image +')');
    this.goHome();
  }

  showVideo(num):void
  {
    this.current = 'video';
    this.step = num;
    this.playVideo({base: this.datas.scenario[this.step].video, inc: this.step}, false);
  }
  showQuestion(num):void
  {
    this.current = 'question';
    this.step = num;
    this.choice = -1;

    this.log(this.datas.scenario[this.step].answers[0].answer);
  }
  showEnd():void
  {
    this.goHome();
    // this.conclusion = this.getComment(this.datas.conclusions, this.total);
  }
  onSplashClick():void
  {
    if (AppConfig.name == 'web'){
      if (!document.fullscreenElement){ document.documentElement.requestFullscreen(); }
    }
    this.showIntroduction();
  }

  goGame():void
  {
    this.current = 'game';
  }

  goHome():void
  {
    this.current = 'splash';
    this.answers = [];
    this.total = 0;
  }

  findGetParameter(parameterName:string):void
  {
      let result = null,
          tmp = [];
      let items = location.search.substr(1).split("&");
      for (let index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
  }

  onClick():void
  {
    if (this.activitySubscription){
      this.activitySubscription.unsubscribe();
      delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      this.log("activitySubscription");
      window.location.reload();
      // window.location.href = window.location+"index.html";
    });
  }
  onClickAnswer(num):void
  {
    this.choice = num;
    if (this.step+1 < this.datas.scenario.length){
      this.showVideo(this.step+1);
    } else {
      this.showEnd();
    }
  }
  onClose():void
  {

  }

  getComment(commentsTab:Array<any>, dist:number):string
  {
    let comment;
    commentsTab.sort((a, b) => Math.sign(b.km - a.km)).forEach(elt => {
      this.log(elt.km);
      if (dist <= elt.km){
        comment = elt.text;
      }
    });
    return comment;
  }




  // --------------------------
  showIntroduction():void
  {
    this.current = 'introduction';
  }
  onInstructionClick():void
  {
    this.goGame();
  }
  showConclusion():void
  {
    this.current = 'conclusion';
  }
  onRestart():void
  {
    this.goHome();
  }
  // --------------------------




  playVideo(folderBaseAndInc, loop){
    this.log('***********');
    this.current = 'video';
    let folder:string = folderBaseAndInc.base;

    let folderSplit = folder.split('*');
    if (folderSplit.length > 1){
      let num = parseInt(folderSplit.shift());
      if (folderBaseAndInc.inc != null){
        num += folderBaseAndInc.inc;
      }
      folder = this.toStringLen(num, 3) + folderSplit.join('');
    }

    if (this.isVP){
      this.playVideoExt(folder);
    } else {
      this.playVideoWeb(folder, loop);
    }
    this.log('current', this.current);
  }
  playVideoWeb(videoFolder:string, loop:boolean){
    this.loop = loop;

    let sel = this.videoFolders.filter((elt) => elt.folder == videoFolder);
    if (sel.length){
      this.currentVideo = videoFolder+'/'+sel[0].video;
      this.videoSubscription = interval(1000).subscribe(() => {
        this.videoUpdate();
      });
    }

  }
  playVideoExt(videoFolder:string){
    this.currentVideo = videoFolder;

    let folderSplit = videoFolder.split('/');
    let folderNum = parseInt(folderSplit.shift());
    // let toPlay = this.videoFolders.filter((videoFolder) => video == videoFolder.video);
    // let folder = parseInt(toPlay[0].folder);

    this.log(window['IDAL'].getControlInterfaces);
    window['IDAL'].getControlInterfaces().then((ifaces) => {
      this.log('got ifaces');
      this.log("load", folderNum);

      ifaces.player.stop().then(() => {
        ifaces.player.playFolder(folderNum).then((ret) => {
          this.log('playing');
        }).catch(function(error) {
          this.log("control interface error");
          // Faire quelque chose d'utile...
        });
      });
    });


    // this.log("click", window['IDAL'].getControlInterfaces());
    // window['IDAL'].getControlInterfaces().then(function(ifaces) {
    //         // L'object ifaces contient toutes les interfaces de contrôle:
    //         //      - ifaces.player
    //         //      - ifaces.serial
    //         //      - ifaces.logger
    //         //      - ifaces.printer
    //         //      - ifaces.contact
    //
    //         // Il est maintenant par example possible de contrôler la lecture vidéo:
    //         ifaces.player.getAllFolders().then(function(folders) {
    //             // Faire quelque chose d'utile...
    //             this.log("Folders received: " + JSON.stringify(folders));
    //         }).catch(function(error) {
    //           this.log("ifaces.player.getAllFolders error");
    //           // Faire quelque chose d'utile...
    //         });
    // }).catch(function(error) {
    //   this.log("control interface error");
    //   // Faire quelque chose d'utile...
    // });




    // this.videoSubscription = interval(1000).subscribe(() => {
    //   this.videoUpdate();
    // });
  }

  getPoster(videoSrc){
    return videoSrc.replace('.mp4', '.jpg');
  }
  videoUpdate(){
    if (this.videoTag && this.videoTag.nativeElement){
      this.videoProgress = Math.round(100 * this.videoTag.nativeElement.currentTime / this.videoTag.nativeElement.duration);
    } else {
      this.videoProgress = 0;
    }
  }
  onVideoEnded(e){
    if (this.videoSubscription){
      this.videoSubscription.unsubscribe();
      delete this.videoSubscription;
    }
    this.videoProgress = 100;

    this.showQuestion(this.step);
  }
  onTimeupdate(e){
    // if (this.videoSubscription){
    //   this.videoSubscription.unsubscribe();
    //   delete this.videoSubscription;
    // }
    // this.videoProgress = 100;
    //
    // this.showQuestion(this.step);
  }
  onVideoClick(){
    // this.current = 'splash';
  }
  toStringLen(num:number, len:number):string
  {
    let ret = ''+num;
    while(ret.length < len){
      ret = '0'+ret;
    }
    return ret;
  }


  log(...txts:any):void
  {
    if (true || this.isVP){
      this.debugTxt += txts.join(', ');
      this.debugTxt += '<br>';
    } else {
      this.log(...txts);
    }
  }

  add(num):void
  {
    this.properties[num].value = Math.min(Math.max(this.properties[num].value+this.properties[num].inc, this.properties[num].min), this.properties[num].max);
    this.sendProperties();
  }
  remove(num):void
  {
    this.properties[num].value = Math.min(Math.max(this.properties[num].value-this.properties[num].inc, this.properties[num].min), this.properties[num].max);
    this.sendProperties();
  }
  sendProperties():void
  {
    this.iframeTag.nativeElement.contentWindow.postMessage(this.properties);
  }

   openHelp(property):void {
     this.showHelp = property;
   }
   closeHelp(property):void {
     delete this.showHelp;
   }
}
